import i18nInst from 'src/i18n';
import { PolicyStore } from '@Policy/store';
import { PolicyTypeEnum } from '@Policy/utils/constants';
import {
  ActionEnum,
  ActionData,
  DlpPolicyItem,
  EnableDisableEnum,
  TargetCapacity,
  SlfException,
} from '@Policy/utils/types';

export const slfActionDataSelector = (s: PolicyStore) => {
  const { setSlfState } = s;
  const { tmSlfFilters } = s.template as DlpPolicyItem;
  const slfOpenShareLinkActionType =
    tmSlfFilters?.slfOpenShareLinkActionType as ActionEnum;
  const slfOpenShareLinkNotifyType =
    tmSlfFilters?.slfOpenShareLinkNotifyType as EnableDisableEnum;
  const { t } = i18nInst;
  const policyType = s.template.policyType;
  const actions: ActionEnum[] = [ActionEnum.removeLink, ActionEnum.pass];
  const actionData: ActionData[] = [
    {
      threatType: t('policy.threatType.openShareLink'),
      handler: setSlfState,
      action: slfOpenShareLinkActionType,
      actionKey: 'slfOpenShareLinkActionType',
      actions,
      notifyType: slfOpenShareLinkNotifyType,
      notifyTypeKey: 'slfOpenShareLinkNotifyType',
      info: t('policy.shareLink.action.info'),
    },
  ];
  if (policyType === PolicyTypeEnum.Box) {
    return actionData;
  } else {
    return [];
  }
};

export const slfExceptionListSelector = (s: PolicyStore) => {
  const policy = s.template as DlpPolicyItem;
  const { t } = i18nInst;
  //for target search feature, It is better to process the policy target data in advance
  const slfExceptionList: SlfException[] =
    policy?.tmSlfFilters?.slfExceptionList || [];
  if (slfExceptionList.length === 0) {
    return slfExceptionList;
  }
  const newSlfExceptionList = slfExceptionList.map((item) => {
    const { slfExceptionUsers, slfExceptionPaths } = item;
    // convert slfExceptionUsers to target string
    let targetString = [''];
    if (slfExceptionUsers.capacity === TargetCapacity.empty) {
      targetString = [t(`policy.policyTarget.box.none`)];
    } else if (slfExceptionUsers.capacity === TargetCapacity.all) {
      //means all user
      targetString = [t(`policy.shareLink.exceptionUser.all`)];
    } else {
      targetString = [
        ...slfExceptionUsers.targetGroups,
        ...slfExceptionUsers.targets,
      ].map((target) => target.title);
    }

    return {
      slfExceptionUsers: targetString,
      slfExceptionPaths,
    };
  });
  return newSlfExceptionList;
};
